/** @jsx jsx */
import { FC } from 'react';
import { css, jsx, SerializedStyles } from '@emotion/core';
import { useSelector } from 'react-redux';
import { selectTenant } from 'state/tenant';
import { Theme } from 'features/Theme';

const styles = {
  icon: (theme: Theme): SerializedStyles => css`
    display: block;
    margin: -${theme.mui.spacing(5)}px auto 0;
    max-height: 30px;
  `,
};

interface PropTypes {
  isDsp?: boolean;
}

const CompletionIcon: FC<PropTypes> = ({ isDsp }) => {
  const { tspIcon, completionIcon } = useSelector(selectTenant);
  const path = isDsp ? tspIcon : completionIcon;

  return path ? (
    <img
      css={styles.icon}
      src={path}
      alt="Credit Application Completion Icon"
    />
  ) : null;
};

export default CompletionIcon;
